
import Vue from 'vue'
import { MAX_USERNAME_LENGTH } from '~/modules/defs'

export default Vue.extend({
  methods: {
    submit() {
      const username = (this.$refs.username as HTMLInputElement).value

      if (username.length <= MAX_USERNAME_LENGTH) {
        this.$accessor.settings.setUsername(username)
      }

      this.$accessor.settings.setIgnoreInvalid((this.$refs.ignoreInvalid as HTMLInputElement).checked)

      this.$accessor.settings.save()
    }
  }
})
